export const environment = {
  production: true,
  apiUrl: 'https://api.kiubostudios.com/api/',
  pdfApiUrl: 'https://pdf-api.kiubostudios.com/api/v1/pdfs/',
  communityUrl: 'https://community.kiubostudios.com/',
  socialAuth: {
    googleClientId: '',
    facebookAppId: '',
  },
};
